import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { addRole } from "@/api/system/role";
import { dealRoleType, dealRoleTypeData, stringToArray } from "@/util/utils";
import { mapGetters, mapMutations } from "vuex";
import selectDefaultPage from "@/components/dialog/roleManage/selectDefaultPage.vue";
export default {
  name: "roleFormDialog",
  data: function data() {
    var validateText = function validateText(rule, value, callback) {
      if (!value && value !== 0) {
        switch (rule.field) {
          case "roleName":
            callback(new Error("角色名称不能为空"));
            break;

          case "roleCode":
            callback(new Error("角色标识不能为空"));
            break;

          default:
            callback(new Error("不能为空"));
            break;
        }
      } else if (value.length > 50) {
        switch (rule.field) {
          case "roleName":
            callback(new Error("角色名称输入过长"));
            break;

          case "roleCode":
            callback(new Error("角色标识输入过长"));
            break;

          default:
            callback(new Error("输入过长"));
            break;
        }
      } else {
        callback();
      }
    };

    return {
      labelWidth: "100px",
      viewCoumns: ["roleName", "roleCode", "roleType", "roleDesc", "menus"],
      lableArray: {
        roleName: "角色名称:",
        roleCode: "角色标识:",
        roleType: "角色类型:",
        roleDesc: "角色描述:",
        defaultPage: "默认页:" // menus: "权限:"

      },
      rules: {
        roleName: [{
          required: true,
          validator: validateText,
          trigger: "blur"
        }],
        roleCode: [{
          required: true,
          validator: validateText,
          trigger: "blur"
        }],
        roleType: [{
          required: true,
          validator: validateText,
          trigger: "blur"
        }]
      },
      dealRoleType: dealRoleType,
      dealRoleTypeData: dealRoleTypeData,
      stringToArray: stringToArray,
      disabled: false
    };
  },
  components: {
    selectDefaultPage: selectDefaultPage
  },
  computed: _objectSpread({}, mapGetters(["roleFormData", "roleFormDialog", "dialogVisible", "roleTypeData"])),
  watch: {
    dialogVisible: function dialogVisible(val) {
      if (val) {
        this.disabled = false;
        this.$refs.roleFormData && this.$refs.roleFormData.clearValidate();
      }
    }
  },
  created: function created() {
    console.log(this.roleFormData);
  },
  methods: _objectSpread(_objectSpread({}, mapMutations({
    setDialogVisible: "setDialogVisible",
    setDefaultPageDialog: "setDefaultPageDialog"
  })), {}, {
    closeDialog: function closeDialog() {
      this.setDialogVisible(false);
    },
    handleDialogClose: function handleDialogClose() {
      this.setDialogVisible(false);
    },
    selectDefaultPage: function selectDefaultPage() {
      this.setDefaultPageDialog(true);
    },
    // 提交表单
    submit: function submit(formName) {
      var _this = this;

      this.$refs[formName].validate(function (valid) {
        // console.log("验证结果：", valid);
        if (valid) {
          _this.disabled = true;
          var _this$roleFormData = _this.roleFormData,
              roleId = _this$roleFormData.roleId,
              roleName = _this$roleFormData.roleName,
              roleCode = _this$roleFormData.roleCode,
              roleDesc = _this$roleFormData.roleDesc,
              roleType = _this$roleFormData.roleType,
              defaultPageId = _this$roleFormData.defaultPageId;
          var query = {
            roleName: roleName,
            roleCode: roleCode,
            roleDesc: roleDesc,
            roleType: roleType,
            // defaultPage: defaultPageId,
            dsType: 0,
            // 老版内诊接口要求必传的参数,我也不知道是啥
            status: _this.roleFormDialog.status
          };

          if (_this.roleFormDialog.status === "edit") {
            Object.assign(query, {
              roleId: roleId
            });
          }

          addRole(query).then(function (res) {
            console.log("提交表单结果：", res);

            if (res.data.code == 0) {
              _this.setDialogVisible(false);

              _this.$parent.getTableData();

              _this.$message.closeAll();

              _this.$message.success("恭喜你，操作成功");
            }
          }).catch(function (err) {
            console.log("err:", err);
            _this.disabled = false;

            _this.$message.closeAll();

            _this.$message.error("操作失败");
          });
        } else {
          _this.disabled = false;
          return false;
        }
      });
    }
  })
};